import styled from 'styled-components'
import { compose, propOr } from 'ramda'
import Play from './play.svg'
import Pause from './pause.svg'

type Color = 'black' | 'white'

const colors: { [key in Color]: string } = {
  black: '#000000',
  white: '#FFFFFF',
}

interface PlayerIconProps extends React.HTMLAttributes<HTMLElement> {
  color?: Color
}

const fromProps: (props: PlayerIconProps) => Color = propOr('black', 'color')
const selectColor = (color: Color): string => colors[color]
const selectColorFromProps = compose(selectColor, fromProps)

export const PlayIcon = styled(Play)<PlayerIconProps>`
  cursor: pointer;
  fill: ${selectColorFromProps};

  path {
    fill: ${selectColorFromProps};
  }
`
export const PauseIcon = styled(Pause)<PlayerIconProps>`
  cursor: pointer;
  fill: ${selectColorFromProps};

  path {
    fill: ${selectColorFromProps};
  }
`
